module.exports = __webpack_public_path__ + "static/media/bieres_01_thumb_hover.1ef36640.png";